import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import SalesReport from '../../pages/reports/SalesReport';
import PurchaseReport from '../../pages/reports/PurchaseReport';
import InventoryReport from '../../pages/reports/InventoryReport';
import BillingReports from './BillingReports';
import CreditCustomersReport from '../../pages/reports/CreditCustomersReport';
import InvoiceProfitLossReport from '../../pages/reports/InvoiceProfitLossReport';
import ProductsReport from '../../pages/reports/ProductsReport';

const Reports = () => {
  return (
    <Routes>
      <Route path="sales" element={<SalesReport />} />
      <Route path="purchases" element={<PurchaseReport />} />
      <Route path="inventory" element={<InventoryReport />} />
      <Route path="billing" element={<BillingReports />} />
      <Route path="invoice-profit-loss" element={<InvoiceProfitLossReport />} />
      <Route path="credit-customers" element={<CreditCustomersReport />} />
      <Route path="products" element={<ProductsReport />} />
      <Route path="*" element={<Navigate to="/reports/credit-customers" replace />} />
    </Routes>
  );
};

export default Reports; 